import { createFileRoute } from "@tanstack/react-router";
import { viewerHomeRoute, ViewerHome } from "@/app-clients/viewer-home";

export const Route = createFileRoute("/profile")({
    ssr: viewerHomeRoute.ssr,
    loader: viewerHomeRoute.loader,
    head: viewerHomeRoute.head,
    component: ViewerHome,
});
